/* eslint-disable import/no-cycle */
import i18n from '../../i18n/i18n';
import WidgetSettingFormField from '../shared/widgets/WidgetSettingFormField';
import {BaseWidgetConfig} from '../shared/widgets/baseWidgetConfig';
import {ValidationRules} from '../../utils/validationRules';
import {Operation} from '../../models/operation';
import {iconSelects} from './orderWidgetConfigIcon';

export class OrderOperatorWidgetConfig extends BaseWidgetConfig {
  // eslint-disable-next-line class-methods-use-this
  get tabs() {
    return [
      {
        key: 'settings',
        label: i18n.t('widget.WidgetSettingsModal.settingConfigTabTitle'),
      },
      {
        key: 'data',
        label: i18n.t('widget.WidgetSettingsModal.dataConfigTabTitle'),
      },
    ];
  }

  settings = [
    {
      id: 'loadDaysPast',
      label: i18n.t('orderWidget.settings.loadDays.past'),
      type: WidgetSettingFormField.fieldTypes.Number,
      unit: i18n.t('orderWidget.settings.loadDays.unit'),
      defaultValue: 15,
      validations: [ValidationRules.required],
    },
    {
      id: 'loadDaysFuture',
      label: i18n.t('orderWidget.settings.loadDays.future'),
      type: WidgetSettingFormField.fieldTypes.Number,
      unit: i18n.t('orderWidget.settings.loadDays.unit'),
      defaultValue: 15,
      validations: [ValidationRules.required],
    },
    {
      id: 'color.planned',
      label: i18n.t('orderWidget.settings.color.planned'),
      type: WidgetSettingFormField.fieldTypes.Color,
      defaultValue: '#FEF7EA',
    },
    {
      id: 'color.paused',
      label: i18n.t('orderWidget.settings.color.paused'),
      type: WidgetSettingFormField.fieldTypes.Color,
      defaultValue: '#F3F3F3',
    },
    {
      id: 'color.active',
      label: i18n.t('orderWidget.settings.color.active'),
      type: WidgetSettingFormField.fieldTypes.Color,
      defaultValue: '#E8F4FF',
    },
    {
      id: 'color.finished',
      label: i18n.t('orderWidget.settings.color.finished'),
      type: WidgetSettingFormField.fieldTypes.Color,
      defaultValue: '#EDF9E8',
    },
    {
      id: 'color.aborted',
      label: i18n.t('orderWidget.settings.color.aborted'),
      type: WidgetSettingFormField.fieldTypes.Color,
      defaultValue: '#F9E3E6',
    },
    {
      id: 'color.disabled',
      label: i18n.t('orderWidget.settings.color.disabled'),
      type: WidgetSettingFormField.fieldTypes.Color,
      defaultValue: '#CCCCCC',
    },
    ...iconSelects,
  ];

  data = [
    {
      id: 'properties',
      label: i18n.t('orderWidget.settings.properties'),
      type: WidgetSettingFormField.fieldTypes.PropertiesSelectDisplayField,
      modelOptions: Operation.allDisplayableProperties(this.rootStore),
      defaultValue: [
        'status',
        'plannedStartDate',
        'plannedStartTime',
        'plannedEndTime',
        'order.no',
        'order.material.no',
        'order.material.name',
        'order.plannedQuantity',
      ],
    },
    {
      id: 'propertiesFinished',
      label: i18n.t('orderWidget.settings.propertiesFinished'),
      type: WidgetSettingFormField.fieldTypes.PropertiesSelectDisplayField,
      modelOptions: Operation.allDisplayableProperties(this.rootStore),
      defaultValue: [
        'status',
        'actualStartDate',
        'actualStartTime',
        'actualEndTime',
        'order.no',
        'order.material.no',
        'order.material.name',
        'order.actualQuantity',
      ],
    },
    {
      id: 'sortOrderForFinishedOrders',
      label: i18n.t('orderWidget.settings.sortOrderForFinishedOrders'),
      type: WidgetSettingFormField.fieldTypes.Select,
      validations: [ValidationRules.required],
      defaultValue: 'desc',
      options: [
        {
          value: 'asc',
          label: i18n.t('orderWidget.settings.sortOrder.asc.label'),
          helpText: i18n.t('orderWidget.settings.sortOrder.asc.help'),
        },
        {
          value: 'desc',
          label: i18n.t('orderWidget.settings.sortOrder.desc.label'),
          helpText: i18n.t('orderWidget.settings.sortOrder.desc.help'),
        },
      ],
    },
  ];

  getOrderTableColumnsPlanned() {
    return this.getSelectedProperties('data', 'properties');
  }

  getOrderTableColumnsFinished() {
    return this.getSelectedProperties('data', 'propertiesFinished');
  }
}
